import { PopperTooltip } from "~/common/components/Tooltip";
import { LinkButton } from "~/common/components/Link";
import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import type { ReactNode } from "react";

export const DownloadContentButton = (props: {
  onClick: () => void;
  label: ReactNode;
  labelHover?: ReactNode;
  isLoading: boolean;
  className?: string;
  "data-test-id"?: string;
}) => (
  <PopperTooltip hideTooltip={!props.labelHover} tooltipContent={props.labelHover} placement={"bottom-end"}>
    <LinkButton
      data-test-id={props["data-test-id"]}
      iconBefore={props.isLoading ? <CircleSpinner /> : <Icon type={IconType.Download} />}
      onClick={props.onClick}
      disabled={props.isLoading}
      className={props.className}
    >
      {props.label}
    </LinkButton>
  </PopperTooltip>
);
